import { render } from "./Button.vue?vue&type=template&id=ead41978"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__